// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"DC-z","smallCardRow":"EC-z","largeCardRow":"FC-z","productSearchRow":"GC-z","curatedRow":"HC-z"};